<div class="row" *ngIf="shouldVisible">
    <div class="col-sm-10">
        <ul>
            <li class="pagination" *ngIf="pages.length>0" [ngClass]="{disabled: paginationCtrls.first}">
                <a (click)="goToFirstPage()">
					&laquo; </a>
            </li>
            <li class="pagination" *ngIf="pages.length>0" [ngClass]="{disabled: paginationCtrls.prev}">
                <a (click)="goToPreviousPage()">
					&lt;</a>
            </li>
            <li class="pagination" *ngIf="activePageIndex > 5 && pages.length > 15">
                <a class="disabled" href="" (click)="$event.preventDefault()">....</a>
            </li>

            <li class="pagination" [hidden]="activePageIndex - 3 > i || activePageIndex + 3 < i" *ngFor="let page of pages; let i = index">
                <a (click)="sendPageNo(i)" [ngClass]="{active: activePageIndex === i}">{{page}}</a>
            </li>
            <!-- <ng-container *ngIf="activePageIndex - 3 > i || activePageIndex + 3 < i"> -->
            <!-- <li class="pagination" [hidden]="activePageIndex - 3 > i || activePageIndex + 3 < i" *ngFor="let page of pages; let i = index">
					<a (click)="sendPageNo(i)" [ngClass]="{active: activePageIndex === i}">{{page}}</a>
				</li> -->
            <!-- </ng-container> -->

            <li class="pagination" *ngIf="activePageIndex < pages.length - 5 && pages.length > 15">
                <a class="disabled" href="" (click)="$event.preventDefault()">....</a>
            </li>
            <li class="pagination" *ngIf="pages.length>0" [ngClass]="{disabled: paginationCtrls.next}">
                <a (click)="goToNextPage()">
					&gt;</a>
            </li>
            <li class="pagination" *ngIf="pages.length>0" [ngClass]="{disabled: paginationCtrls.last}">
                <a (click)="goToLastPage()">
					&raquo;</a>
            </li>
        </ul>
    </div>
    <div class="col-sm-2">
        <div class="text-right" *ngIf="pages.length>0">
            <select class="btn btn-secondary" [(ngModel)]="perpage" (change)="sendPerPage()">
					<!-- <option [selected]="perpage" *ngIf="perpage !== (10 || 20 || 50 || 100 || 500)" disabled [ngValue]="perpage">{{perpage}}</option> -->
					<!-- <option [selected]="perpage==10" *ngIf="10 >= perpage" [ngValue]="10">10</option>
					<option [selected]="perpage==20" *ngIf="20 >= perpage" [ngValue]="20">20</option>
					<option [selected]="perpage==50" *ngIf="50 >= perpage" [ngValue]="50">50</option>
					<option [selected]="perpage==100" *ngIf="100 >= perpage" [ngValue]="100">100</option>
					<option [selected]="perpage==200" *ngIf="200 >= perpage" [ngValue]="200">200</option>
					<option [selected]="perpage==500" *ngIf="500 >= perpage" [ngValue]="500">500</option> -->
					<option [ngValue]="10">10</option>
					<option [ngValue]="20">20</option>
					<option [ngValue]="50">50</option>
					<option [ngValue]="100">100</option>
					<option [ngValue]="200">200</option>
					<option [ngValue]="500">500</option>
					<option [ngValue]="1000" *ngIf="isNapsDbt">1000</option>
			</select>
        </div>
    </div>
</div>
